import { colors } from './colors';

export const popover = {
  error: {
    color: colors.red,
  },
  defaultTheme: {
    color: colors.text,
  },
  success: {
    color: colors.greenLight,
  },
  warn: {
    color: colors.orangeLight,
  },
};
